var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgKeyCmd = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5,9A3.5,3.5,0,1,0,15,5.5V7H9V5.5A3.5,3.5,0,1,0,5.5,9H7v6H5.5A3.5,3.5,0,1,0,9,18.5V17h6v1.5A3.5,3.5,0,1,0,18.5,15H17V9ZM17,5.5A1.5,1.5,0,1,1,18.5,7H17ZM7,18.5A1.5,1.5,0,1,1,5.5,17H7ZM7,7H5.5A1.5,1.5,0,1,1,7,5.5Zm8,8H9V9h6Zm3.5,2A1.5,1.5,0,1,1,17,18.5V17Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgKeyCmd);
export default ForwardRef;